<script>
  import { Link, useFocus } from "svelte-navigator";
  const focus = useFocus();
</script>

<svelte:head>
  <meta name="description"
  content="404 - Page not found">
  <title>404 - Page not found</title>
</svelte:head>

<h1 use:focus>Oops!</h1>
<h2>404 Not found</h2>
<p>It looks like this page made and Irish Goodbye...</p>

<br />
<span class='buttons-404'>
  <Link on:click={() => window.history.back()} to=''>Go back</Link>
  <Link to="/">Go home</Link>
</span>
<br />

<div class='gif-container'>
  <iframe
    title="I'm gone GIF"
    src="https://giphy.com/embed/2tPqk7osSfDdb6BQPC"
    width="100%"
    height="100%"
    style="position:absolute"
    frameBorder="0"
    class="giphy-embed"
    allowFullScreen
  />
</div>

<style>
  iframe {
    left: 0;
  }
  .gif-container {
    margin-top: 1rem;
    width:100%;
    height:0;
    padding-bottom:56%;
    position:relative;
  }
</style>
